















import { Component, Emit, Ref, Vue, Watch } from 'vue-property-decorator';
import HeaderTab from './header-tab.vue';
import BottomTab from './bottom-tab.vue';
import { BottomTabType, HeaderTabType } from '@/config/page-tab';
import { getUserPrizeTabInfo } from '@/business/red-dot';

@Component({
	  components: {
	    HeaderTab,
	  	BottomTab,
	  },
})
export default class PageTab extends Vue {
  @Ref('headerTab') headerTab!: HeaderTab;
  private redDotInfo = {
	  [HeaderTabType.couponlist]: false,
	  [HeaderTabType.stamplist]: false,
	  [HeaderTabType.displaycouponlist]: false,
  };
  /** 奖品数量信息 */
  private countInfo: {
    [key: string]: undefined | number;
  } = {
    [HeaderTabType.couponlist]: undefined,
	  [HeaderTabType.stamplist]: undefined,
	  [HeaderTabType.displaycouponlist]: undefined,
  };
  private isShowBottomRedDot = false;

  @Watch('$route.query')
  private onRouteQueryChanged(routeInfo) {
    // 监听路由参数变化，如果有refresh_page_tab=1标识，则重新刷新下tab列表数据
    const { refresh_page_tab: refreshPageTab } = routeInfo;
    if (refreshPageTab === '1') {
      this.initData();
    }
  }

  private	async created() {
    await this.initData();
  }

  private async initData() {
    const prizeTabInfo = await getUserPrizeTabInfo();
    Object.keys(prizeTabInfo).forEach((tab) => {
      this.redDotInfo[tab] = prizeTabInfo[tab].hasRedDot;
      this.countInfo[tab] = prizeTabInfo[tab].count;
    });
    this.isShowBottomRedDot = this.calcBottomRedDot();
    // 数据拿到后，主动更新下header tab的红点信息
    this.headerTab.updateCurrentRouteRedDot();
  }

  private handleRedDotInfoUpdate() {
	  // 只有header-tab的红点展示完时，才主动取消bottm-tab的红点，其余情况由bottom-tab自己控制
	  const allHasRedDot = this.calcBottomRedDot();
	  if (!allHasRedDot) {
	    this.isShowBottomRedDot = false;
	  }
  }

  private calcBottomRedDot() {
	  return this.redDotInfo[HeaderTabType.couponlist]
		 || this.redDotInfo[HeaderTabType.stamplist]
		 || this.redDotInfo[HeaderTabType.displaycouponlist];
  }

  @Emit('clearRedDot')
  private clearRedDot({ tab, key }: {tab: 'header'|'bottom', key: string}) {
	  if (tab === 'bottom' && key === BottomTabType.couponlist) {
	    this.isShowBottomRedDot = false;
	    return;
	  }
		 if (tab === 'header') {
			 if (!this.redDotInfo[key]) {
	      // 如果已经是false，则不处理
				 return;
			 }
	    this.redDotInfo[key] = false;
	    this.handleRedDotInfoUpdate();
	  }
  }
}
